const APP_URL = import.meta.env.VITE_APP_URL || 'https://app.tempora.lat';
export const isLandingDomain = window.location.hostname === 'tempora.lat' || window.location.hostname === 'www.tempora.lat';

/**
 * Returns the dashboard URL based on the current domain.
 * If on landing domain, it points to the app subdomain.
 */
export const getDashboardUrl = () => {
    if (isLandingDomain) {
        return `${APP_URL}/dashboard`;
    }
    return '/';
};

/**
 * Returns the correct URL for login.
 */
export const getLoginUrl = () => {
    if (isLandingDomain) {
        return `${APP_URL}/login`;
    }
    return '/login';
};

/**
 * Returns the correct URL for registration.
 */
export const getRegisterUrl = () => {
    if (isLandingDomain) {
        return `${APP_URL}/register`;
    }
    return '/register';
};

/**
 * Returns the default authenticated path based on the domain.
 * On landing domain (tempora.lat), the app lives at /dashboard on the app domain.
 * On app domain (app.tempora.lat), the app lives at /dashboard.
 */
export const getHomePath = () => {
    return isLandingDomain ? `${APP_URL}/dashboard` : '/dashboard';
};
